function initBannerAnimation() {
	if (typeof gsap === "undefined") {
		return;
	}

	const banner = document.querySelector("#banner");
	if (!banner) {
		return;
	}

	const title = banner.querySelector(".bigTitle");
	const eyebrow = banner.querySelector(".top small");
	const textElements = [...banner.querySelectorAll(".texts p, .texts .btn")];
	const figure = banner.querySelector("figure");
	const vector = banner.querySelector(".vector");
	const animatedElements = [title, eyebrow, ...textElements, figure, vector].filter(Boolean);
	const media = gsap.matchMedia();

	media.add("(prefers-reduced-motion: reduce)", () => {
		gsap.set(animatedElements, { clearProps: "all" });
	});

	media.add("(prefers-reduced-motion: no-preference)", () => {
		const timeline = gsap.timeline({
			defaults: {
				duration: 0.9,
				ease: "power3.out",
			},
			onComplete: () => gsap.set(animatedElements, { clearProps: "all" }),
		});

		timeline
			.fromTo(title, { autoAlpha: 0, y: 36 }, { autoAlpha: 1, y: 0 })
			.fromTo(eyebrow, { autoAlpha: 0, y: 24 }, { autoAlpha: 0.4, y: 0 }, "-=0.65")
			.fromTo(textElements, { autoAlpha: 0, y: 28 }, { autoAlpha: 1, y: 0, stagger: 0.12 }, "-=0.45")
			.fromTo(figure, { autoAlpha: 0, clipPath: "inset(0 100% 0 0)" }, { autoAlpha: 1, clipPath: "inset(0 0% 0 0)", duration: 1.1 }, "-=0.8")
			.fromTo(vector, { autoAlpha: 0, x: -28 }, { autoAlpha: 1, x: 0, duration: 0.95 }, "-=0.7");

		return () => timeline.kill();
	});
}
function initBannerLPAnimation() {
	if (typeof gsap === "undefined") {
		return;
	}

	const bannerLP = document.querySelector("#bannerLP");
	if (!bannerLP) {
		return;
	}

	const seal = bannerLP.querySelector(".container img");
	const title = bannerLP.querySelector("h1");
	const button = bannerLP.querySelector(".btn");
	const figure = bannerLP.querySelector("figure");
	const image = bannerLP.querySelector("figure img");
	const animatedElements = [seal, title, button, figure, image].filter(Boolean);
	const media = gsap.matchMedia();

	media.add("(prefers-reduced-motion: reduce)", () => {
		gsap.set(animatedElements, { clearProps: "all" });
	});

	media.add("(prefers-reduced-motion: no-preference)", () => {
		const timeline = gsap.timeline({
			defaults: {
				ease: "power3.out",
			},
			onComplete: () => gsap.set(animatedElements, { clearProps: "all" }),
		});

		gsap.set(seal, { autoAlpha: 0, y: 26, scale: 0.9, transformOrigin: "50% 50%" });
		gsap.set(title, { autoAlpha: 0, y: 34 });
		gsap.set(button, { autoAlpha: 0, y: 22 });
		gsap.set(figure, { autoAlpha: 0 });
		gsap.set(image, { scale: 1.04, transformOrigin: "50% 50%" });

		timeline
			.to(figure, { autoAlpha: 1, duration: 0.8 })
			.to(image, { scale: 1, duration: 1.4 }, "-=0.8")
			.to(seal, { autoAlpha: 1, y: 0, scale: 1, duration: 0.7 }, "-=0.9")
			.to(title, { autoAlpha: 1, y: 0, duration: 0.75 }, "-=0.45")
			.to(button, { autoAlpha: 1, y: 0, duration: 0.55 }, "-=0.32");

		return () => timeline.kill();
	});
}
function initEvolutionLPAnimation() {
	if (typeof gsap === "undefined") {
		return;
	}

	const evolution = document.querySelector("#evolution");
	if (!evolution) {
		return;
	}

	const textElements = [...evolution.querySelectorAll(".texts h2, .texts p, .texts .btn")];
	const line = evolution.querySelector(".texts hr");
	const figures = [...evolution.querySelectorAll(".gallery figure")];
	const images = [...evolution.querySelectorAll(".gallery img")];
	const animatedElements = [...textElements, line, ...figures, ...images].filter(Boolean);
	const media = gsap.matchMedia();

	media.add("(prefers-reduced-motion: reduce)", () => {
		gsap.set(animatedElements, { clearProps: "all" });
	});

	media.add("(prefers-reduced-motion: no-preference)", () => {
		const timeline = gsap.timeline({
			paused: true,
			defaults: {
				ease: "power3.out",
			},
			onComplete: () => gsap.set(animatedElements, { clearProps: "all" }),
		});

		gsap.set(textElements, { autoAlpha: 0, y: 30 });
		gsap.set(line, { scaleX: 0, transformOrigin: "left center" });
		gsap.set(figures, { autoAlpha: 0, y: 34, clipPath: "inset(8% 0 0 0)" });
		gsap.set(images, { scale: 1.035, transformOrigin: "50% 50%" });

		timeline
			.to(textElements, { autoAlpha: 1, y: 0, duration: 0.68, stagger: 0.09 })
			.to(line, { scaleX: 1, duration: 0.72 }, "-=0.35")
			.to(figures, { autoAlpha: 1, y: 0, clipPath: "inset(0% 0 0 0)", duration: 0.72, stagger: 0.08 }, "-=0.55")
			.to(images, { scale: 1, duration: 0.95, stagger: 0.05 }, "-=0.82");

		const observer = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (!entry.isIntersecting) {
					return;
				}

				timeline.play();
				observer.disconnect();
			});
		}, { threshold: 0.25 });

		observer.observe(evolution);

		return () => {
			observer.disconnect();
			timeline.kill();
		};
	});
}
function initInstitutionalCycleAnimation() {
	if (typeof gsap === "undefined") {
		return;
	}

	const institutionalCycle = document.querySelector("#institutionalCycle");
	if (!institutionalCycle) {
		return;
	}

	const leftElements = [...institutionalCycle.querySelectorAll(".institutionalCycle__left h2, .institutionalCycle__left p")];
	const leftLine = institutionalCycle.querySelector(".institutionalCycle__left hr");
	const mark = institutionalCycle.querySelector(".institutionalCycle__mark img");
	const rightText = institutionalCycle.querySelector(".institutionalCycle__right p");
	const rightLine = institutionalCycle.querySelector(".institutionalCycle__right hr");
	const bars = [...institutionalCycle.querySelectorAll(".institutionalCycle__bars span")];
	const vector = institutionalCycle.querySelector(".institutionalCycle__bars img");
	const animatedElements = [...leftElements, leftLine, mark, rightText, rightLine, ...bars, vector].filter(Boolean);
	const media = gsap.matchMedia();

	media.add("(prefers-reduced-motion: reduce)", () => {
		gsap.set(animatedElements, { clearProps: "all" });
	});

	media.add("(prefers-reduced-motion: no-preference)", () => {
		const timeline = gsap.timeline({
			paused: true,
			defaults: {
				ease: "power3.out",
			},
			onComplete: () => gsap.set(animatedElements, { clearProps: "all" }),
		});

		gsap.set(leftElements, { autoAlpha: 0, y: 32 });
		gsap.set(leftLine, { scaleX: 0, transformOrigin: "left center" });
		gsap.set(mark, { autoAlpha: 0, scale: 0.82, rotate: -4, transformOrigin: "50% 50%" });
		gsap.set(rightText, { autoAlpha: 0, y: 30 });
		gsap.set(rightLine, { scaleX: 0, transformOrigin: "left center" });
		gsap.set(bars, { scaleY: 0, transformOrigin: "bottom center" });
		gsap.set(vector, { autoAlpha: 0, clipPath: "inset(0 100% 0 0)" });

		timeline
			.to(leftElements, { autoAlpha: 1, y: 0, duration: 0.68, stagger: 0.1 })
			.to(leftLine, { scaleX: 1, duration: 0.72 }, "-=0.35")
			.to(mark, { autoAlpha: 1, scale: 1, rotate: 0, duration: 0.75 }, "-=0.62")
			.to(rightText, { autoAlpha: 1, y: 0, duration: 0.68 }, "-=0.35")
			.to(rightLine, { scaleX: 1, duration: 0.7 }, "-=0.3")
			.to(bars, { scaleY: 1, duration: 0.85, stagger: 0.08 }, "-=0.35")
			.to(vector, { autoAlpha: 1, clipPath: "inset(0 0% 0 0)", duration: 0.95 }, "-=0.85");

		const observer = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (!entry.isIntersecting) {
					return;
				}

				timeline.play();
				observer.disconnect();
			});
		}, { threshold: 0.25 });

		observer.observe(institutionalCycle);

		return () => {
			observer.disconnect();
			timeline.kill();
		};
	});
}
function initAboutAnimation() {
	if (typeof gsap === "undefined") {
		return;
	}

	const about = document.querySelector("#about");
	if (!about) {
		return;
	}

	const headlineElements = [...about.querySelectorAll(".about__headline h2, .about__headline p")];
	const contentElements = [...about.querySelectorAll(".about__content p, .about__content .btn")];
	const seal = about.querySelector(".about__seal img");
	const divider = about.querySelector(".about__divider hr");
	const image = about.querySelector(".about__image");
	const animatedElements = [...headlineElements, ...contentElements, seal, divider, image].filter(Boolean);
	const media = gsap.matchMedia();

	media.add("(prefers-reduced-motion: reduce)", () => {
		gsap.set(animatedElements, { clearProps: "all" });
	});

	media.add("(prefers-reduced-motion: no-preference)", () => {
		const timeline = gsap.timeline({
			paused: true,
			defaults: {
				ease: "power3.out",
			},
			onComplete: () => gsap.set(animatedElements, { clearProps: "all" }),
		});

		gsap.set(headlineElements, { autoAlpha: 0, y: 32 });
		gsap.set(contentElements, { autoAlpha: 0, y: 28 });
		gsap.set(seal, { autoAlpha: 0, scale: 0.72, transformOrigin: "50% 50%" });
		gsap.set(divider, { scaleY: 0, transformOrigin: "top center" });
		gsap.set(image, { autoAlpha: 0, clipPath: "inset(0 0 0 100%)" });

		timeline
			.to(headlineElements, { autoAlpha: 1, y: 0, duration: 0.65, stagger: 0.1 })
			.to(seal, { autoAlpha: 1, scale: 1, duration: 0.7 }, "-=0.5")
			.to(contentElements, { autoAlpha: 1, y: 0, duration: 0.6, stagger: 0.08 }, "-=0.4")
			.to(image, { autoAlpha: 1, clipPath: "inset(0 0 0 0%)", duration: 0.75 }, "-=0.5")
			.to(divider, { scaleY: 1, duration: 0.95 }, "-=0.7");

		const observer = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (!entry.isIntersecting) {
					return;
				}

				timeline.play();
				observer.disconnect();
			});
		}, { threshold: 0.35 });

		observer.observe(about);

		return () => {
			observer.disconnect();
			timeline.kill();
		};
	});
}
function initAboutInsideAnimation() {
	if (typeof gsap === "undefined") {
		return;
	}

	const aboutInside = document.querySelector("#aboutInside");
	if (!aboutInside) {
		return;
	}

	const leftElements = [...aboutInside.querySelectorAll(".boxLeft .hat, .boxLeft h1, .boxLeft p, .boxLeft .btn")];
	const vector = aboutInside.querySelector(".boxLeft .vector");
	const line = aboutInside.querySelector(".boxLeft hr");
	const images = [...aboutInside.querySelectorAll(".boxRight img")];
	const bottomLine = aboutInside.querySelector(".container > hr");
	const animatedElements = [...leftElements, vector, line, ...images, bottomLine].filter(Boolean);
	const media = gsap.matchMedia();

	media.add("(prefers-reduced-motion: reduce)", () => {
		gsap.set(animatedElements, { clearProps: "all" });
	});

	media.add("(prefers-reduced-motion: no-preference)", () => {
		const timeline = gsap.timeline({
			paused: true,
			defaults: {
				ease: "power3.out",
			},
			onComplete: () => gsap.set(animatedElements, { clearProps: "all" }),
		});

		gsap.set(leftElements, { autoAlpha: 0, y: 30 });
		gsap.set(vector, { autoAlpha: 0, x: -28 });
		gsap.set(line, { scaleX: 0, transformOrigin: "left center" });
		gsap.set(images, { autoAlpha: 0, y: 36, clipPath: "inset(10% 0 0 0)" });
		gsap.set(bottomLine, { scaleX: 0, transformOrigin: "left center" });

		timeline
			.to(leftElements, { autoAlpha: 1, y: 0, duration: 0.68, stagger: 0.09 })
			.to(vector, { autoAlpha: 1, x: 0, duration: 0.85 }, "-=0.45")
			.to(line, { scaleX: 1, duration: 0.72 }, "-=0.6")
			.to(images, { autoAlpha: 1, y: 0, clipPath: "inset(0% 0 0 0)", duration: 0.75, stagger: 0.1 }, "-=0.75")
			.to(bottomLine, { scaleX: 1, duration: 0.8 }, "-=0.45");

		const observer = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (!entry.isIntersecting) {
					return;
				}

				timeline.play();
				observer.disconnect();
			});
		}, { threshold: 0.25 });

		observer.observe(aboutInside);

		return () => {
			observer.disconnect();
			timeline.kill();
		};
	});
}
function initContextAnimation() {
	if (typeof gsap === "undefined") {
		return;
	}

	const context = document.querySelector("#context");
	if (!context) {
		return;
	}

	const leftElements = [...context.querySelectorAll(".boxLeft h2, .boxLeft p")];
	const line = context.querySelector(".boxLeft hr");
	const rightElements = [...context.querySelectorAll(".boxRight p")];
	const building = context.querySelector(".bottom figure");
	const vector = context.querySelector(".bottom .vector");
	const animatedElements = [...leftElements, line, ...rightElements, building, vector].filter(Boolean);
	const media = gsap.matchMedia();

	media.add("(prefers-reduced-motion: reduce)", () => {
		gsap.set(animatedElements, { clearProps: "all" });
	});

	media.add("(prefers-reduced-motion: no-preference)", () => {
		const timeline = gsap.timeline({
			paused: true,
			defaults: {
				ease: "power3.out",
			},
			onComplete: () => gsap.set(animatedElements, { clearProps: "all" }),
		});

		gsap.set(leftElements, { autoAlpha: 0, y: 34 });
		gsap.set(line, { scaleX: 0, transformOrigin: "left center" });
		gsap.set(rightElements, { autoAlpha: 0, y: 30 });
		gsap.set(building, { autoAlpha: 0, y: 52, scale: 0.96, transformOrigin: "50% 100%" });
		gsap.set(vector, { autoAlpha: 0, scaleX: 0.92, transformOrigin: "center center" });

		timeline
			.to(leftElements, { autoAlpha: 1, y: 0, duration: 0.65, stagger: 0.1 })
			.to(line, { scaleX: 1, duration: 0.75 }, "-=0.35")
			.to(rightElements, { autoAlpha: 1, y: 0, duration: 0.72, stagger: 0.14 }, "-=0.55")
			.to(vector, { autoAlpha: 1, scaleX: 1, duration: 0.9 }, "-=0.25")
			.to(building, { autoAlpha: 1, y: 0, scale: 1, duration: 0.6 }, "-=1.05");

		const observer = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (!entry.isIntersecting) {
					return;
				}

				timeline.play();
				observer.disconnect();
			});
		}, { threshold: 0.3 });

		observer.observe(context);

		return () => {
			observer.disconnect();
			timeline.kill();
		};
	});
}
function initSecurityAnimation() {
	if (typeof gsap === "undefined") {
		return;
	}

	const security = document.querySelector("#security");
	if (!security) {
		return;
	}

	const text = security.querySelector("small");
	if (!text) {
		return;
	}

	const media = gsap.matchMedia();

	media.add("(prefers-reduced-motion: reduce)", () => {
		gsap.set(text, { clearProps: "all" });
	});

	media.add("(prefers-reduced-motion: no-preference)", () => {
		const timeline = gsap.timeline({
			paused: true,
			delay: 0.25,
			defaults: {
				ease: "power3.out",
			},
			onComplete: () => gsap.set(text, { clearProps: "all" }),
		});

		gsap.set(text, { autoAlpha: 0, y: 18, clipPath: "inset(0 100% 0 0)" });

		timeline.to(text, {
			autoAlpha: 0.6,
			y: 0,
			clipPath: "inset(0 0% 0 0)",
			duration: 0.9,
		});

		const observer = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (!entry.isIntersecting) {
					return;
				}

				timeline.play();
				observer.disconnect();
			});
		}, { threshold: 0.45 });

		observer.observe(security);

		return () => {
			observer.disconnect();
			timeline.kill();
		};
	});
}
function initAreasAnimation() {
	if (typeof gsap === "undefined") {
		return;
	}

	const areas = document.querySelector("#areas");
	if (!areas) {
		return;
	}

	const textElements = [...areas.querySelectorAll(".texts h2, .texts p, .texts .btn")];
	const vector = areas.querySelector(".texts .vector");
	const items = [...areas.querySelectorAll("ul li")];
	const itemContent = items.flatMap((item) => [...item.querySelectorAll("img, h3")]);
	const animatedElements = [...textElements, vector, ...items, ...itemContent].filter(Boolean);
	const media = gsap.matchMedia();

	media.add("(prefers-reduced-motion: reduce)", () => {
		gsap.set(animatedElements, { clearProps: "all" });
	});

	media.add("(prefers-reduced-motion: no-preference)", () => {
		const timeline = gsap.timeline({
			paused: true,
			defaults: {
				ease: "power3.out",
			},
			onComplete: () => gsap.set(animatedElements, { clearProps: "all" }),
		});

		gsap.set(textElements, { autoAlpha: 0, y: 30 });
		gsap.set(vector, { autoAlpha: 0, scaleY: 0, transformOrigin: "top center" });
		gsap.set(items, { autoAlpha: 0, y: 34, clipPath: "inset(12% 0 0 0)" });
		gsap.set(itemContent, { autoAlpha: 0, y: 18 });

		timeline
			.to(textElements, { autoAlpha: 1, y: 0, duration: 0.72, stagger: 0.1 })
			.to(vector, { autoAlpha: 1, scaleY: 1, duration: 1 }, "-=0.35")
			.to(items, { autoAlpha: 1, y: 0, clipPath: "inset(0% 0 0 0)", duration: 0.7, stagger: 0.1 }, "-=0.75")
			.to(itemContent, { autoAlpha: 1, y: 0, duration: 0.55, stagger: 0.04 }, "-=0.55");

		const observer = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (!entry.isIntersecting) {
					return;
				}

				timeline.play();
				observer.disconnect();
			});
		}, { threshold: 0.3 });

		observer.observe(areas);

		return () => {
			observer.disconnect();
			timeline.kill();
		};
	});
}
function initAreasInsideAnimation() {
	if (typeof gsap === "undefined") {
		return;
	}

	const areasInside = document.querySelector("#areasInside");
	if (!areasInside) {
		return;
	}

	const topTitle = areasInside.querySelector(".top .titleBox h2");
	const topArrow = areasInside.querySelector(".top .titleBox img");
	const topTexts = [...areasInside.querySelectorAll(".top .texts p")];
	const items = [...areasInside.querySelectorAll("ul li")];
	const itemTitles = items.map((item) => item.querySelector(".title")).filter(Boolean);
	const itemTitleContent = items.flatMap((item) => [...item.querySelectorAll(".title img, .title h3")]);
	const itemTexts = items.flatMap((item) => [...item.querySelectorAll(".texts p")]);
	const animatedElements = [topTitle, topArrow, ...topTexts, ...items, ...itemTitles, ...itemTitleContent, ...itemTexts].filter(Boolean);
	const media = gsap.matchMedia();

	media.add("(prefers-reduced-motion: reduce)", () => {
		gsap.set(animatedElements, { clearProps: "all" });
	});

	media.add("(prefers-reduced-motion: no-preference)", () => {
		const timeline = gsap.timeline({
			paused: true,
			defaults: {
				ease: "power3.out",
			},
			onComplete: () => gsap.set(animatedElements, { clearProps: "all" }),
		});

		gsap.set(topTitle, { autoAlpha: 0, y: 30 });
		gsap.set(topArrow, { autoAlpha: 0, y: -18, scale: 0.86, transformOrigin: "50% 50%" });
		gsap.set(topTexts, { autoAlpha: 0, y: 26 });
		gsap.set(items, { autoAlpha: 0, y: 34, clipPath: "inset(8% 0 0 0)" });
		gsap.set(itemTitles, { x: -28 });
		gsap.set(itemTitleContent, { autoAlpha: 0, x: -18 });
		gsap.set(itemTexts, { autoAlpha: 0, y: 18 });

		timeline
			.to(topTitle, { autoAlpha: 1, y: 0, duration: 0.68 })
			.to(topArrow, { autoAlpha: 1, y: 0, scale: 1, duration: 0.55 }, "-=0.38")
			.to(topTexts, { autoAlpha: 1, y: 0, duration: 0.62, stagger: 0.1 }, "-=0.35")
			.to(items, { autoAlpha: 1, y: 0, clipPath: "inset(0% 0 0 0)", duration: 0.68, stagger: 0.06 }, "-=0.25")
			.to(itemTitles, { x: 0, duration: 0.58, stagger: 0.06 }, "-=0.6")
			.to(itemTitleContent, { autoAlpha: 1, x: 0, duration: 0.5, stagger: 0.025 }, "-=0.48")
			.to(itemTexts, { autoAlpha: 1, y: 0, duration: 0.5, stagger: 0.025 }, "-=0.42");

		const observer = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (!entry.isIntersecting) {
					return;
				}

				timeline.play();
				observer.disconnect();
			});
		}, { threshold: 0.25 });

		observer.observe(areasInside);

		return () => {
			observer.disconnect();
			timeline.kill();
		};
	});
}
function initPartnersAnimation() {
	if (typeof gsap === "undefined") {
		return;
	}

	const partners = document.querySelector("#partners");
	if (!partners) {
		return;
	}

	const boxes = [...partners.querySelectorAll(".box")];
	if (!boxes.length) {
		return;
	}

	const animatedElements = boxes.flatMap((box) => [
		box.querySelector("figure"),
		box.querySelector("figure .img-person"),
		box.querySelector("figcaption .info"),
		box.querySelector("figcaption a"),
		...box.querySelectorAll(".high h3, .high .arrow, .high h4"),
		...box.querySelectorAll(".description p"),
		...box.querySelectorAll(".bookBox .book"),
	]).filter(Boolean);
	const media = gsap.matchMedia();

	media.add("(prefers-reduced-motion: reduce)", () => {
		gsap.set(animatedElements, { clearProps: "all" });
	});

	media.add("(prefers-reduced-motion: no-preference)", () => {
		const timelines = new Map();
		const observer = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (!entry.isIntersecting) {
					return;
				}

				const timeline = timelines.get(entry.target);
				if (timeline) {
					timeline.play();
				}

				observer.unobserve(entry.target);
			});
		}, { threshold: 0.22 });

		boxes.forEach((box) => {
			const figure = box.querySelector("figure");
			const personImage = box.querySelector("figure .img-person");
			const info = box.querySelector("figcaption .info");
			const social = box.querySelector("figcaption a");
			const highItems = [...box.querySelectorAll(".high h3, .high .arrow, .high h4")];
			const paragraphs = [...box.querySelectorAll(".description p")];
			const books = [...box.querySelectorAll(".bookBox .book")];
			const boxElements = [figure, personImage, info, social, ...highItems, ...paragraphs, ...books].filter(Boolean);

			const timeline = gsap.timeline({
				paused: true,
				defaults: {
					ease: "power3.out",
				},
				onComplete: () => gsap.set(boxElements, { clearProps: "all" }),
			});

			gsap.set(figure, { autoAlpha: 0, y: 34, clipPath: "inset(8% 0 0 0)" });
			gsap.set(personImage, { scale: 1.035, transformOrigin: "50% 50%" });
			gsap.set(info, { autoAlpha: 0, y: 24 });
			gsap.set(social, { autoAlpha: 0, scale: 0.9, transformOrigin: "50% 50%" });
			gsap.set(highItems, { autoAlpha: 0, y: 26 });
			gsap.set(paragraphs, { autoAlpha: 0, y: 22 });
			gsap.set(books, { autoAlpha: 0, y: 24 });

			timeline
				.to(figure, { autoAlpha: 1, y: 0, clipPath: "inset(0% 0 0 0)", duration: 0.78 })
				.to(personImage, { scale: 1, duration: 1.1 }, "-=0.78")
				.to(info, { autoAlpha: 1, y: 0, duration: 0.62 }, "-=0.45")
				.to(social, { autoAlpha: 1, scale: 1, duration: 0.52 }, "-=0.36")
				.to(highItems, { autoAlpha: 1, y: 0, duration: 0.6, stagger: 0.08 }, "-=0.22")
				.to(paragraphs, { autoAlpha: 1, y: 0, duration: 0.5, stagger: 0.035 }, "-=0.2")
				.to(books, { autoAlpha: 1, y: 0, duration: 0.55, stagger: 0.08 }, "-=0.2");

			timelines.set(box, timeline);
			observer.observe(box);
		});

		return () => {
			observer.disconnect();
			timelines.forEach((timeline) => timeline.kill());
		};
	});
}
function initTeamAnimation() {
	if (typeof gsap === "undefined") {
		return;
	}

	const team = document.querySelector("#team");
	if (!team) {
		return;
	}

	const elements = [...team.querySelectorAll(".hat, .team-card")];
	if (!elements.length) {
		return;
	}

	const media = gsap.matchMedia();

	media.add("(prefers-reduced-motion: reduce)", () => {
		gsap.set(elements, { clearProps: "all" });
	});

	media.add("(prefers-reduced-motion: no-preference)", () => {
		const timeline = gsap.timeline({
			paused: true,
			defaults: {
				duration: 0.58,
				ease: "power3.out",
			},
			onComplete: () => gsap.set(elements, { clearProps: "all" }),
		});

		gsap.set(elements, { autoAlpha: 0, y: 24 });

		timeline.to(elements, { autoAlpha: 1, y: 0, stagger: 0.08 });

		const observer = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (!entry.isIntersecting) {
					return;
				}

				timeline.play();
				observer.disconnect();
			});
		}, { threshold: 0.25 });

		observer.observe(team);

		return () => {
			observer.disconnect();
			timeline.kill();
		};
	});
}
function initBlogAnimation() {
	if (typeof gsap === "undefined") {
		return;
	}

	const blog = document.querySelector("#blog");
	if (!blog) {
		return;
	}

	const topTitle = blog.querySelector(".top h2");
	const topArrow = blog.querySelector(".top h2 a");
	const topText = blog.querySelector(".top p");
	const cards = [...blog.querySelectorAll(".blog-card")];
	const more = blog.querySelector(".more");
	const animatedElements = [topTitle, topArrow, topText, ...cards, more].filter(Boolean);
	const media = gsap.matchMedia();

	media.add("(prefers-reduced-motion: reduce)", () => {
		gsap.set(animatedElements, { clearProps: "all" });
	});

	media.add("(prefers-reduced-motion: no-preference)", () => {
		const timeline = gsap.timeline({
			paused: true,
			defaults: {
				ease: "power3.out",
			},
			onComplete: () => gsap.set(animatedElements, { clearProps: "all" }),
		});

		gsap.set(topTitle, { autoAlpha: 0, x: -34, clipPath: "inset(0 100% 0 0)" });
		gsap.set(topArrow, { autoAlpha: 0, x: -18, scale: 0.86, transformOrigin: "50% 50%" });
		gsap.set(topText, { autoAlpha: 0, x: -32, clipPath: "inset(0 100% 0 0)" });
		gsap.set(cards, { autoAlpha: 0, y: 34, clipPath: "inset(10% 0 0 0)" });
		gsap.set(more, { autoAlpha: 0, x: -20 });

		timeline
			.to(topTitle, { autoAlpha: 1, x: 0, clipPath: "inset(0 0% 0 0)", duration: 0.75 })
			.to(topArrow, { autoAlpha: 1, x: 0, scale: 1, duration: 0.55 }, "-=0.35")
			.to(topText, { autoAlpha: 1, x: 0, clipPath: "inset(0 0% 0 0)", duration: 0.7 }, "-=0.5")
			.to(cards, { autoAlpha: 1, y: 0, clipPath: "inset(0% 0 0 0)", duration: 0.7, stagger: 0.12 }, "-=0.25")
			.to(more, { autoAlpha: 1, x: 0, duration: 0.55 }, "-=0.35");

		const observer = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (!entry.isIntersecting) {
					return;
				}

				timeline.play();
				observer.disconnect();
			});
		}, { threshold: 0.25 });

		observer.observe(blog);

		return () => {
			observer.disconnect();
			timeline.kill();
		};
	});
}
function initBoxNewsAnimation() {
	if (typeof gsap === "undefined") {
		return;
	}

	const boxNews = document.querySelector("#boxNews");
	if (!boxNews) {
		return;
	}

	const featured = boxNews.querySelector(".boxNews__featured");
	const hat = boxNews.querySelector(".boxNews__aside .hat");
	const items = [...boxNews.querySelectorAll(".boxNews__aside li")];
	const more = boxNews.querySelector(".boxNews__more");
	const animatedElements = [featured, hat, ...items, more].filter(Boolean);
	const media = gsap.matchMedia();

	media.add("(prefers-reduced-motion: reduce)", () => {
		gsap.set(animatedElements, { clearProps: "all" });
	});

	media.add("(prefers-reduced-motion: no-preference)", () => {
		const timeline = gsap.timeline({
			paused: true,
			defaults: {
				ease: "power2.out",
			},
			onComplete: () => gsap.set(animatedElements, { clearProps: "all" }),
		});

		gsap.set(featured, { autoAlpha: 0, y: 18, scale: 0.99, transformOrigin: "50% 100%" });
		gsap.set(hat, { autoAlpha: 0, y: 12 });
		gsap.set(items, { autoAlpha: 0, y: 16 });
		gsap.set(more, { autoAlpha: 0, y: 12 });

		timeline
			.to(featured, { autoAlpha: 1, y: 0, scale: 1, duration: 0.58 })
			.to(hat, { autoAlpha: 1, y: 0, duration: 0.42 }, "-=0.35")
			.to(items, { autoAlpha: 1, y: 0, duration: 0.46, stagger: 0.055 }, "-=0.25")
			.to(more, { autoAlpha: 1, y: 0, duration: 0.4 }, "-=0.22");

		const observer = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (!entry.isIntersecting) {
					return;
				}

				timeline.play();
				observer.disconnect();
			});
		}, { threshold: 0.18 });

		observer.observe(boxNews);

		return () => {
			observer.disconnect();
			timeline.kill();
		};
	});
}

function initBoxArticlesAnimation() {
	if (typeof gsap === "undefined") {
		return;
	}

	const boxArticles = document.querySelector("#boxArticles");
	if (!boxArticles) {
		return;
	}

	const topElements = [...boxArticles.querySelectorAll(".boxArticles__top .hat, .boxArticles__nav button")];
	const cards = [...boxArticles.querySelectorAll(".blog-card")];
	const more = boxArticles.querySelector(".boxArticles__more");
	const animatedElements = [...topElements, ...cards, more].filter(Boolean);
	const media = gsap.matchMedia();

	media.add("(prefers-reduced-motion: reduce)", () => {
		gsap.set(animatedElements, { clearProps: "all" });
	});

	media.add("(prefers-reduced-motion: no-preference)", () => {
		const timeline = gsap.timeline({
			paused: true,
			defaults: {
				ease: "power2.out",
			},
			onComplete: () => gsap.set(animatedElements, { clearProps: "all" }),
		});

		gsap.set(topElements, { autoAlpha: 0, y: 12 });
		gsap.set(cards, { autoAlpha: 0, y: 18 });
		gsap.set(more, { autoAlpha: 0, y: 12 });

		timeline
			.to(topElements, { autoAlpha: 1, y: 0, duration: 0.42, stagger: 0.06 })
			.to(cards, { autoAlpha: 1, y: 0, duration: 0.5, stagger: 0.06 }, "-=0.18")
			.to(more, { autoAlpha: 1, y: 0, duration: 0.4 }, "-=0.2");

		const observer = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (!entry.isIntersecting) {
					return;
				}

				timeline.play();
				observer.disconnect();
			});
		}, { threshold: 0.18 });

		observer.observe(boxArticles);

		return () => {
			observer.disconnect();
			timeline.kill();
		};
	});
}
function initNewsletterAnimation() {
	if (typeof gsap === "undefined") {
		return;
	}

	const newsletter = document.querySelector("#newsletter");
	if (!newsletter) {
		return;
	}

	const textElements = [...newsletter.querySelectorAll(".texts h2, .texts p")];
	const line = newsletter.querySelector("hr");
	const boxForm = newsletter.querySelector(".boxForm");
	const mailIcon = newsletter.querySelector(".boxForm > img");
	const formElements = [...newsletter.querySelectorAll("form input, form .btn")];
	const vector = newsletter.querySelector(".vector");
	const animatedElements = [...textElements, line, boxForm, mailIcon, ...formElements, vector].filter(Boolean);
	const media = gsap.matchMedia();

	media.add("(prefers-reduced-motion: reduce)", () => {
		gsap.set(animatedElements, { clearProps: "all" });
	});

	media.add("(prefers-reduced-motion: no-preference)", () => {
		const timeline = gsap.timeline({
			paused: true,
			defaults: {
				ease: "power3.out",
			},
			onComplete: () => gsap.set(animatedElements, { clearProps: "all" }),
		});

		gsap.set(textElements, { autoAlpha: 0, x: -34, clipPath: "inset(0 100% 0 0)" });
		gsap.set(line, { scaleX: 0, transformOrigin: "left center" });
		gsap.set(boxForm, { autoAlpha: 0, x: -36, clipPath: "inset(0 100% 0 0)" });
		gsap.set(mailIcon, { autoAlpha: 0, x: -18, scale: 0.88, transformOrigin: "50% 50%" });
		gsap.set(formElements, { autoAlpha: 0, x: -24 });
		gsap.set(vector, { autoAlpha: 0, x: -28 });

		timeline
			.to(textElements, { autoAlpha: 1, x: 0, clipPath: "inset(0 0% 0 0)", duration: 0.65, stagger: 0.1 })
			.to(line, { scaleX: 1, duration: 0.72 }, "-=0.35")
			.to(boxForm, { autoAlpha: 1, x: 0, clipPath: "inset(0 0% 0 0)", duration: 0.75 }, "-=0.5")
			.to(vector, { autoAlpha: 1, x: 0, duration: 0.75 }, "-=0.7")
			.to(mailIcon, { autoAlpha: 1, x: 0, scale: 1, duration: 0.55 }, "-=0.45")
			.to(formElements, { autoAlpha: 1, x: 0, duration: 0.52, stagger: 0.07 }, "-=0.35");

		const observer = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (!entry.isIntersecting) {
					return;
				}

				timeline.play();
				observer.disconnect();
			});
		}, { threshold: 0.3 });

		observer.observe(newsletter);

		return () => {
			observer.disconnect();
			timeline.kill();
		};
	});
}